import React from 'react';
import { PlatformAdminRow } from '../../../../models/entities/platform/platformSuperAdmin';
import { userInfo } from '../../../../models/entities/user';
import PlatformSuperAdminsPageHeader from './components/PlatformSuperAdminsPageHeader';
import PlatformSuperAdminsGrid from './components/PlatformSuperAdminsGrid';
import {
    PlatformErrorBanner,
    PlatformGridWrapper,
    PlatformHeaderWrapper,
    PlatformPageWrapper
} from '../shared/platformPageStyles';

type Props = {
    rows: PlatformAdminRow[];
    users: userInfo[];
    localization: any;
    showLoader: boolean;
    lastError: string | null;
    fetchPlatformAdmins: () => void;
    addPlatformAdmin: (email: string) => Promise<void>;
    revokePlatformAdmin: (email: string) => void;
};

const PlatformSuperAdminsPage = ({
    rows,
    users,
    localization,
    showLoader,
    lastError,
    fetchPlatformAdmins,
    addPlatformAdmin,
    revokePlatformAdmin
}: Props) => {
    return (
        <PlatformPageWrapper>
            <PlatformHeaderWrapper>
                <PlatformSuperAdminsPageHeader
                    localization={localization}
                    showLoader={showLoader}
                    users={users}
                    onRefresh={fetchPlatformAdmins}
                    onAdd={addPlatformAdmin}
                />
                {lastError && <PlatformErrorBanner style={{ margin: '12px 0 0' }}>{lastError}</PlatformErrorBanner>}
            </PlatformHeaderWrapper>
            <PlatformGridWrapper>
                <PlatformSuperAdminsGrid rows={rows} showLoader={showLoader} localization={localization} onRevoke={revokePlatformAdmin} />
            </PlatformGridWrapper>
        </PlatformPageWrapper>
    );
};

export default PlatformSuperAdminsPage;
